import { RuntimeConfigService } from './runtime-config';
import { NgxIndexedDB } from './ngx-index-db';
import { StorageCollections } from '../enum/storage-collections.enum';
import * as _ from 'lodash';

export function runtimeConfigFactory(environment): Function {
  return (runtimeConfigService: RuntimeConfigService) => {
    return () => {
      let promise = new Promise((resolve, reject) => {
        let db = new NgxIndexedDB('hubconnect_db', 1);
        db.openDatabase(1, evt => {
          this.createDefaultObjectStores(evt, [
            StorageCollections.SECURITY,
            StorageCollections.CONFIG,
            StorageCollections.HUBCONNECT
          ]);
        }).then(() => {
          db.getByIndex('config', 'name', 'config').then(
            result => {
              let config = _.get(result, 'value', '');
              if (config) {
                environment.runtime = JSON.parse(config).runtime;
                runtimeConfigService.$resolve(environment.runtime);
              }
              db.dbWrapper.db.close(); // Close connection after setting api endpoints
              return resolve();
            },
            error => {
              db.dbWrapper.db.close(); // Close connection to avoid blocking db
              console.log(error);
              return resolve();
            }
          );
        })
      })
      return promise;
    };
  };
}
